import dayjs, { ConfigType } from "dayjs";
import { forwardRef } from "react";

import { formatDuration } from "@/shared/formatters";

type FormatDurationProps = {
  start: ConfigType;
  end: ConfigType;
} & React.ComponentProps<"span">;

export const FormatDuration = forwardRef<HTMLSpanElement, FormatDurationProps>(
  (props, ref) => {
    const { start, end, ...spanProps } = props;
    const diff = dayjs(end).diff(dayjs(start));
    return (
      <span ref={ref} {...spanProps}>
        {formatDuration(diff)}
      </span>
    );
  },
);
